import React from "react";

const StatementCategories = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Statement of Categories of Documents</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
        style={{ textAlign: "justify" }}
      >
        <ul>
          <li>
            The documents as required under the provisions of various laws,
            rules and regulations are kept by the Corporation.
          </li>
          <li>
            The Corporationis also following Haryana Govt. Act, Rules and
            Regulations.
          </li>
          <li>
            Further the following record of stakeholders of the Corporation has
            been prepared on the regular basis:-
            <br />
            1. Shareholders Registers
            <br />
            2. Share Transfer Register
            <br />
            3. Share Transmission Register
            <br />
            4. Duplicate Share Register
            <br />
            5. Director&rsquo;s Register
            <br />
            6. Attendance registers of various meetings
            <br />
            7. Minutes book of various meetings as per Companies Act.2013
            <br />
            8. Register of RTI Appeals.
            <p>&nbsp;</p>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default StatementCategories;
